const BASE = '/api';

export interface CustomPrice {
  date: string;
  pricePerNight: number | null;
  minNights: number | null;
  promoPrice: number | null;
  note: string | null;
  isBlocked: boolean;
}

export interface ReservationSummary {
  id: number;
  checkIn: string;
  checkOut: string;
  guestName: string | null;
  numberOfGuests: number | null;
  status: string;
  platform: string | null;
}

export interface CalendarData {
  hasBookingSite: boolean;
  basePricePerNight: number | null;
  raisedPriceJson: string | null;
  customPrices: CustomPrice[];
  reservations: ReservationSummary[];
}

export interface PricingUpsertPayload {
  dates: string[];
  pricePerNight: number | null;
  minNights: number | null;
  promoPrice: number | null;
  note: string | null;
  isBlocked: boolean;
}

export async function getCalendarData(
  apartmentId: number,
  from: string,
  to: string,
  token: string
): Promise<CalendarData> {
  const res = await fetch(
    `${BASE}/apartments/${apartmentId}/booking-site/pricing?from=${from}&to=${to}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getCalendarDataBatch(
  apartmentIds: number[],
  from: string,
  to: string,
  token: string
): Promise<Record<number, CalendarData>> {
  const res = await fetch(
    `${BASE}/apartments/booking-site/pricing-batch?ids=${apartmentIds.join(',')}&from=${from}&to=${to}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function upsertPricing(
  apartmentId: number,
  payload: PricingUpsertPayload,
  token: string
): Promise<CustomPrice[]> {
  const res = await fetch(`${BASE}/apartments/${apartmentId}/booking-site/pricing`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Save failed' }));
    throw new Error(err.message || 'Save failed');
  }
  return res.json();
}

export async function deletePricing(
  apartmentId: number,
  date: string,
  token: string
): Promise<void> {
  const res = await fetch(`${BASE}/apartments/${apartmentId}/booking-site/pricing/${date}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Delete failed');
}
